import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Transporation = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.875 33.9c.3 2 2.105 3.6 4.21 3.6 2.104 0 3.908-1.6 4.209-3.6h1.804c.501 0 .902-.4.902-.9v-8.6c0-.2-.1-.4-.2-.5L39.089 17c-.2-.2-.501-.4-.802-.4h-6.816V7.4c0-.5-.4-.9-.901-.9H.902C.401 6.5 0 6.9 0 7.4V33c0 .5.4.9.902.9h5.212c.501 1.8 2.105 3.1 4.11 3.1 2.004 0 3.607-1.3 4.109-3.1h18.542ZM29.667 32H14.533c-.3-2.1-2.105-3.7-4.21-3.7-2.305.1-4.109 1.7-4.31 3.7H1.805V8.3h27.863V32Zm1.905-13.6h6.314l3.608 5.1h-9.922v-5.1ZM42.296 32h-1.002c-.501-1.8-2.105-3.1-4.11-3.1-2.004 0-3.608 1.3-4.21 3.1h-1.402v-6.7h10.724V32Z"
  }));
});
Transporation.displayName = 'Transporation';
Transporation.defaultProps = {
  'aria-label': 'Transporation'
};
export default Transporation;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/Transporation.js
// module id = 3712
// module chunks = 11